import SourceErrorsModalComponent from '../components/sourceErrorsModal/sourceErrorsModal.component';

let SOURCES_TABLE_CONFIG = {
  options: {
    tabName: 'sources',
    uri: '/batches'
  },
  columns: [{
    name: 'name',
    label: 'Source',
    type: 'table-grid-text-cell'
  }, {
    name: 'status',
    label: 'Status',
    formatFilter: 'uppercase',
    type: 'table-grid-text-cell'
  }, {
    name: 'totalRows',
    label: 'Rows',
    type: 'table-grid-text-cell'
  }, {
    name: 'sourceErrors',
    label: 'Errors',
    type: 'table-grid-modal-link-cell',
    modalOptions: {
      uri: '/batches/batchId/sourceFiles/fileName/sourceErrors',
      uriFieldMappings: {
        batchId: 'batchId',
        name: 'fileName'
      },
      contentComponent: SourceErrorsModalComponent,
      contentClass: 'sourceErrors_modal',
      linkText: {
        hasData: 'View Errors',
        noData: 'No Errors'
      }
    }
  }]
};

module.exports = SOURCES_TABLE_CONFIG;


// WEBPACK FOOTER //
// ./app/models/sourcesTableConfig.js